export var dataLayerPush = function (obj) {
    obj = obj || {};
    var debug = 'dataLayer.push(' + JSON.stringify(obj) + ')';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(obj);
    console.log(debug);
};
export function retry(maxRetries, action, handleError) {
    return action().catch(function (err) {
        if (maxRetries <= 0) {
            console.error('retry ~ err', err);
            return handleError(err);
        }
        return retry(maxRetries - 1, action, handleError);
    });
}
export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
